class UrlHelper {

  getSiteUrl(siteId, full = false) {
    const base = full ? window.location.origin : '';
    return base + '/site/' + encodeURI(siteId);
  }

  getDashboardUrl(siteId, dashboardId, full = false) {
    return this.getSiteUrl(siteId, full) + '/dashboard/' + encodeURI(dashboardId);
  }

  getDashboardQRUrl(siteId, dashboardId) {
    return this.getDashboardUrl(siteId, dashboardId) + '/qr-code';
  }
}

export const urlHelper = new UrlHelper();